/* thumbs-horizontal.js — mobile hero arrows + smooth, user-first thumb rail
   - Uses Flexslider API when available; falls back to nav anchors or thumbs
   - Keeps active thumb visible, but NOT while the user is dragging the rail
*/
(function () {
  // Shortcuts
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }

  function getRoot() { return $('.flexslider.product_gallery'); }
  function getRail(root) { return root ? $('.flex-control-thumbs', root) : null; }
  function getThumbItems(rail) { return rail ? Array.from(rail.children).filter(el => el.tagName === 'LI') : []; }
  function getActiveThumbIndex(rail) {
    const items = getThumbItems(rail);
    const i = items.findIndex(li => li.classList.contains('flex-active') || li.classList.contains('active'));
    return i >= 0 ? i : 0;
  }

  // --- Autoscroll helper (respects "panning" lock) ---
  function keepActiveInView(rail, force = false) {
    if (!rail) return;
    if (!force && rail.dataset.panning === '1') return; // don't fight the user's drag
    const items = getThumbItems(rail);
    const i = getActiveThumbIndex(rail);
    const active = items[i];
    if (!active) return;
    const left = active.offsetLeft;
    const right = left + active.offsetWidth;
    const cur = rail.scrollLeft;
    const viewRight = cur + rail.clientWidth;
    if (left < cur) rail.scrollTo({ left: Math.max(left - 8, 0), behavior: 'smooth' });
    else if (right > viewRight) rail.scrollTo({ left: right - rail.clientWidth + 8, behavior: 'smooth' });
  }

  // --- Primary navigation (Flexslider API → nav anchors → thumbs) ---
  function navViaFlexslider(dir, root) {
    if (window.jQuery && jQuery.fn && typeof jQuery.fn.flexslider === 'function') {
      const $root = jQuery(root);
      if ($root.length) { $root.flexslider(dir); return true; }
    }
    const anchor = $(`.flex-direction-nav .flex-${dir}`, root);
    if (anchor) { anchor.click(); return true; }
    return false;
  }
  function navViaThumbs(dir, root) {
    const rail = getRail(root);
    if (!rail) return false;
    const items = getThumbItems(rail);
    if (!items.length) return false;
    const cur = getActiveThumbIndex(rail);
    const nextIdx = dir === 'next' ? (cur + 1) % items.length : (cur - 1 + items.length) % items.length;
    const clickEl = items[nextIdx].querySelector('img') || items[nextIdx].firstElementChild;
    if (clickEl) {
      clickEl.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      setTimeout(() => keepActiveInView(rail, true), 60);
      return true;
    }
    return false;
  }
  function move(dir, e) {
    if (e) { e.preventDefault(); e.stopPropagation(); }
    const root = getRoot();
    if (!root) return;
    if (navViaFlexslider(dir, root)) {
      const rail = getRail(root);
      setTimeout(() => keepActiveInView(rail, true), 60);
      return;
    }
    navViaThumbs(dir, root);
  }

  // --- Overlay hero arrows (mobile CSS already displays them) ---
  function ensureHeroArrows(root) {
    let prev = $('.hero-prev', root);
    let next = $('.hero-next', root);
    if (!prev) {
      prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'hero-nav hero-prev';
      prev.setAttribute('aria-label', 'Previous image');
      root.appendChild(prev);
    }
    if (!next) {
      next = document.createElement('button');
      next.type = 'button';
      next.className = 'hero-nav hero-next';
      next.setAttribute('aria-label', 'Next image');
      root.appendChild(next);
    }
    // Reset listeners by cloning to avoid duplicates
    const prevClone = prev.cloneNode(true); prev.replaceWith(prevClone);
    const nextClone = next.cloneNode(true); next.replaceWith(nextClone);
    prevClone.addEventListener('click', (e) => move('prev', e), true);
    nextClone.addEventListener('click', (e) => move('next', e), true);
  }

  // --- Thumb rail: sharp touch/drag + panning lock + small observer ---
  function wireThumbRail(rail) {
    if (!rail || rail.dataset.thumbWired === '1') return;

    rail.style.touchAction = 'pan-x';

    // Track when the user is actively panning (so we don't auto-recenter)
    let sx = 0, sy = 0, moved = false, panTimer = null;
    const THRESH = 6;
    function startPanning() {
      rail.dataset.panning = '1';
      if (panTimer) clearTimeout(panTimer);
    }
    function stopPanningSoon() {
      if (panTimer) clearTimeout(panTimer);
      panTimer = setTimeout(() => { rail.dataset.panning = '0'; panTimer = null; }, 120);
    }

    rail.addEventListener('touchstart', (e) => {
      const t = e.touches[0]; sx = t.clientX; sy = t.clientY; moved = false;
      startPanning();
    }, { passive: true, capture: true });

    rail.addEventListener('touchmove', (e) => {
      const t = e.touches[0];
      const dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > THRESH && Math.abs(dx) > Math.abs(dy)) moved = true;
      startPanning();
    }, { passive: true, capture: true });

    rail.addEventListener('touchend', () => {
      if (moved) {
        // suppress the synthetic click after a drag
        rail.dataset.dragging = '1';
        setTimeout(() => { rail.dataset.dragging = '0'; }, 0);
      }
      stopPanningSoon();
    }, { capture: true });

    rail.addEventListener('touchcancel', () => { stopPanningSoon(); }, { capture: true });

    // If the user wheel-scrolls (desktop trackpads), also respect panning
    rail.addEventListener('wheel', () => { startPanning(); stopPanningSoon(); }, { passive: true });

    // Prevent click after drag; otherwise align to active on real clicks
    rail.addEventListener('click', (e) => {
      if (rail.dataset.dragging === '1') { e.preventDefault(); e.stopPropagation(); rail.dataset.dragging = '0'; return; }
      setTimeout(() => keepActiveInView(rail, true), 60);
    }, true);

    // Watch only class changes within the rail (cheap); skip while panning
    const obs = new MutationObserver(() => {
      if (rail.dataset.panning === '1') return;
      setTimeout(() => keepActiveInView(rail), 0);
    });
    obs.observe(rail, { subtree: true, attributes: true, attributeFilter: ['class'] });

    rail.dataset.thumbWired = '1';
  }

  // --- Init (retry briefly while Flexslider builds) ---
  function initOnce() {
    const root = getRoot();
    if (!root) return false;

    ensureHeroArrows(root);

    const rail = getRail(root);
    if (rail) wireThumbRail(rail);

    // If Flexslider replaces the rail, re-wire the new one (scoped observer)
    const watch = new MutationObserver(() => {
      const r = getRail(root);
      if (r && r.dataset.thumbWired !== '1') wireThumbRail(r);
    });
    watch.observe(root, { childList: true, subtree: true });

    // After variant changes, recenter to active thumb
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (t.matches('select[name="id"], [data-variant], [name="id"]')) {
        const r = getRail(root);
        setTimeout(() => keepActiveInView(r, true), 120);
      }
    });

    return true;
  }

  function init() {
    if (initOnce()) return;
    let tries = 0;
    const timer = setInterval(() => { if (initOnce() || ++tries > 40) clearInterval(timer); }, 50);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
